import { Helmet } from "react-helmet-async";

export default function PageMeta({ title, description, image }) {
  const siteName = "Phygital";
  const fullTitle = title ? `${title} | ${siteName}` : siteName;
  const desc = description || "The future of beauty and service experiences";
  const img = image || "";

  return (
    <Helmet>
      <title>{fullTitle}</title>
      <meta name="description" content={desc} />
      <meta property="og:title" content={fullTitle} />
      <meta property="og:description" content={desc} />
      <meta property="og:site_name" content={siteName} />
      <meta property="og:type" content="website" />
      {img && <meta property="og:image" content={img} />}
      <meta name="twitter:card" content={img ? "summary_large_image" : "summary"} />
      <meta name="twitter:title" content={fullTitle} />
      <meta name="twitter:description" content={desc} />
      {img && <meta name="twitter:image" content={img} />}
    </Helmet>
  );
}
